// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-video{position:absolute;width:100%;height:100%;border-radius:5%}.c-video--fallback{position:relative;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);top:0;width:100%;border-top-left-radius:20px;border-top-right-radius:20px}", ""]);
// Exports
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/lib!./node_modules/sass-loader/dist/cjs.js!./src/components/video/video.scss
// module id = 171
// module chunks = 0